import React, { useContext } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { getNotificationPublishState, isNotificationPaused, Notification } from '../../../../../models';
import getFormattedDate from '../../../../../helpers/getFormattedDate';
import { AppTableContext } from '../../../../AppTable/AppTableContext';
import { withSkeleton } from '../../../../AppTable/helpers/withSkeleton';
import DataCell from '../../../../AppTable/cells/DataCell/DataCell';

import classes from './Schedule.module.scss';

const keyPrefix = 'components.notificationsList.notificationsTable.table-parts.schedule';

const Schedule = ({ rowData: notification }: { rowData: Notification }) => {
    const { t } = useTranslation('', { keyPrefix });

    const { environmentId, tableDataTestid } = useContext(AppTableContext);

    const publishState = getNotificationPublishState(notification, environmentId);
    const pausedMode = isNotificationPaused(notification, environmentId);

    return (
        <div className={classes.schedule}>
            {pausedMode && (
                <div className={classes.pausedIndicator} data-testid={`${notification.id}-schedule-paused-indicator-${tableDataTestid}`}>
                    {t('paused')}
                </div>
            )}

            <DataCell
                className={clsx(classes.scheduleInner, { [classes.pausedMode]: pausedMode })}
                data={getFormattedDate(publishState?.startAt)}
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
                id={notification.id}
                testKey="schedule"
                disableConditionalEllipsis
                isDate
            />
        </div>
    );
};

export default withSkeleton({ height: 12, width: 110 })(Schedule);
